<template>
  <div>
    <PageHead title="消防器材管理"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view mr20">
              <div class="query-view-lable">单位名称：</div>
              <a-tree-select
                allowClear
                v-model="queryForm.organization_id"
                class="w200"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="app.treeData"
                placeholder="请选择部门"
                tree-default-expand-all
                :replaceFields="{
                  key: 'id',
                  value: 'id',
                  children: 'treeList',
                  title: 'organizationName'
                }"
              >
              </a-tree-select>
            </div>
            <div class="query-view mr20">
              <div class="query-view-lable">责任人：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入责任人"
                v-model="queryForm.responsiblePeople"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">表单状态：</div>
              <a-select
                allowClear
                class="w200"
                v-model="queryForm.state"
                placeholder="请选择表单状态"
              >
                <template v-for="(item, index) in app.formStatusList">
                  <a-select-option :value="item.value" :key="index">
                    {{ item.label }}
                  </a-select-option>
                </template>
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading"
            >查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()"
            >取消</a-button
          >
        </div>
      </div>
      <div class="search-btns mb20">
        <a-button type="primary" @click="goDetial()" icon="plus">
          新建</a-button
        >
        <a-button
          class="ml10"
          type="primary"
          :loading="exportLoading"
          @click="Export()"
          icon="download"
        >
          导出</a-button
        >
        <span class="statistics">
          检索统计:
          <span>{{ total }}条</span>
        </span>
      </div>

      <!-- 表格 -->
      <a-table
        :rowKey="(record) => record.id"
        :pagination="false"
        :columns="columns"
        :data-source="listData"
        :loading="loading"
      >
        <div slot="order" slot-scope="text, record, index">{{ index + 1 }}</div>
        <div slot="state" class="statusDiv" slot-scope="text">
          <div v-if="text == 0" class="dot0 mr5"></div>
          <div v-if="text == 1" class="dot1 mr5"></div>
          <div v-if="text == 2" class="dot2 mr5"></div>
          <div v-if="text == 3" class="dot3 mr5"></div>
          <div v-if="text == 4" class="dot4 mr5"></div>
          <span v-if="text == 0"> 待提交 </span>
          <span v-if="text == 1"> 正在审批 </span>
          <span v-if="text == 2"> 已归档 </span>
          <span v-if="text == 3"> 退回 </span>
          <span v-if="text == 4"> 取消 </span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button
            type="link"
            class="btn-link"
            @click="goDetial(record.id, 'check')"
          >
            查看
          </a-button>
          <template v-if="record.state == 0">
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="goDetial(record.id)">
              修改
            </a-button>
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="showDeleteConfirm(record.id)"
            >
              删除
            </a-button> </template
          ><a-divider type="vertical" v-if="record.recallButton" />
          <a-button
            v-if="record.recallButton"
            type="link"
            class="btn-link"
            @click="showRecallConfirm(record)"
          >
            撤回
          </a-button>

          <a-divider type="vertical" />
          <a-button type="link" class="btn-link" @click="history(record.id)">
            历史记录
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
    <a-modal
      v-model="ishistory"
      title="历史修改记录"
      :footer="null"
      :width="800"
    >
      <a-table
        :pagination="false"
        :columns="historyColumns"
        :data-source="historyList"
        :row-key="(record) => record.fromVersion"
      >
        <div slot="action" slot-scope="text, record">
          <a-button
            type="link"
            class="btn-link"
            @click="goHistoryDetial(record.id, record.version)"
          >
            查看
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="historyPage"
          :default-current="historyPage"
          :total="historyTotal"
          :pageSize="historySize"
          @change="historyPageChange"
        />
      </div>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'order',
    key: 'order',
    width: 80,
    scopedSlots: { customRender: 'order' }
  },
  {
    title: '单位名称',
    dataIndex: 'unitName',
    key: 'unitName',
    ellipsis: true
  },
  {
    title: '负责人',
    dataIndex: 'responsiblePeople',
    key: 'responsiblePeople',
    ellipsis: true
  },
  {
    title: '消防器材类型',
    dataIndex: 'fireEquipmentType',
    key: 'fireEquipmentType',
    ellipsis: true
  },
  {
    title: '消防器材数量',
    dataIndex: 'number',
    key: 'number',
    ellipsis: true
  },
  {
    title: '表单流程',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'state' },
    ellipsis: true
  },
  {
    title: '创建日期',
    dataIndex: 'createTime',
    key: 'createTime',
    ellipsis: true
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    width: 260,
    align: 'left'
  }
]
const historyColumns = [
  {
    title: '时间',
    dataIndex: 'createTime',
    key: 'createTime'
  },

  {
    title: '修改人',
    dataIndex: 'modifyUserName',
    key: 'modifyUserName',
    ellipsis: true
  },

  {
    title: '表单版本',
    dataIndex: 'fromVersion',
    key: 'fromVersion'
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作'
  }
]
import {
  getFireEquipmentlist,
  delFireEquipment,
  getHistoryList,
  Export
} from './api.js'
import { mapState, mapActions, mapMutations } from 'vuex'
import { recallProcessFn } from '@/utils/utils'
export default {
  data() {
    return {
      page: 1,
      size: 10,
      total: 10,
      loading: false,
      columns,
      queryForm: {},
      listData: [],
      historyColumns,
      ishistory: false,
      historyList: [], //历史版本列表
      historyPage: 1,
      historyTotal: 0,
      historySize: 5,
      historyId: '', // 被查看历史版本的人id
      exportLoading: false
    }
  },
  computed: {
    ...mapState(['app'])
  },
  mounted() {
    this.getorganizeListFn()
    this.subMit()
  },
  methods: {
    // 提交 未审批 可撤回流程
    showRecallConfirm(record) {
      const recallProcessPromise = new Promise((resolve, reject) => {
        recallProcessFn(this, record, resolve, reject, 'basis-fire-equipment')
      })
      recallProcessPromise
        .then((value) => {
          console.log(value)
          this.getFireEquipmentlistFn()
        })
        .catch((error) => {
          console.log(error)
          this.getFireEquipmentlistFn()
        })
    },
    ...mapActions(['getorganizeListFn']),
    Export() {
      // 导出
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      this.exportLoading = true
      Export(params).then((response) => {
        this.exportLoading = false
        this.$message.success('导出成功')

        // resolve(response.data);
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })

        let fileName = '消防器材管理导出.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    // 列表
    getFireEquipmentlistFn() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      getFireEquipmentlist(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.listData = res.data.data
          this.total = res.data.count
        }
      })
    },
    cancel() {
      //取消
      this.queryForm = {}
    },
    // 提交
    subMit() {
      this.page = 1
      this.getFireEquipmentlistFn()
    },

    // 查看修改
    goDetial(id, type) {
      if (type) {
        this.$router.push('/fireEquipmentDetails?id=' + id + '&isEdit=1')
      } else {
        if (id) {
          this.$router.push('/fireEquipmentDetails?id=' + id)
        } else {
          this.$router.push('/fireEquipmentDetails')
        }
      }
    },

    // 删除
    showDeleteConfirm(record) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          this.delFireEquipmentFn(record)
        }
      })
    },
    delFireEquipmentFn(id) {
      delFireEquipment({ id }).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('删除成功')
          this.getFireEquipmentlistFn()
        }
      })
    },
    // 点击分页
    pageChange(pageNumber) {
      this.page = pageNumber
      this.getFireEquipmentlistFn()
    },
    history(id) {
      //查看历史记录
      this.historyId = id
      this.historyLoad()
      this.ishistory = true
    },
    historyLoad() {
      // 获取历史版本列表
      let params = {
        id: this.historyId,
        page: this.historyPage,
        size: this.historySize
      }
      getHistoryList(params).then((res) => {
        if (res.data.code == 0) {
          this.historyList = res.data.data
          this.historyTotal = res.data.count
        }
      })
    },
    // 历史记录分页
    historyPageChange(pageNumber) {
      this.historyPage = pageNumber
      this.historyLoad()
    },
    goHistoryDetial(id, version) {
      this.$router.push({
        path: '/fireEquipmentDetails',
        query: {
          id,
          version,
          isEdit: '1'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 180px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // flex-wrap: wrap;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .query-view-lable {
          width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 5px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}
.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>




// WEBPACK FOOTER //
// src/views/baseInfoManagement/fireEquipment/index.vue